export { default } from './IframeViewer'



// WEBPACK FOOTER //
// ./src/components/IframeViewer/index.js